export default __webpack_public_path__ + "static/media/line-chart.e0c727fb.svg";